import {
  useSelect,
  UseSelectState,
  UseSelectStateChangeOptions,
} from 'downshift';

export const defaultItemToString = (item: any) =>
  item === null || item === undefined ? '' : String(item);

export const nonNullItemToString =
  <T>(itemToStringFn: (item: T) => string = defaultItemToString) =>
  (item: T | undefined | null) =>
    item === null || item === undefined ? '' : itemToStringFn(item);

export function multiselectStateReducer<T>(
  state: UseSelectState<T>,
  actionAndChanges: UseSelectStateChangeOptions<T>
): Partial<UseSelectState<T>> {
  const { changes, type } = actionAndChanges;

  switch (type) {
    case useSelect.stateChangeTypes.MenuKeyDownEnter:
    case useSelect.stateChangeTypes.MenuKeyDownSpaceButton:
    case useSelect.stateChangeTypes.ItemClick:
      return {
        ...changes,
        isOpen: true, // keep menu open after selection.
        highlightedIndex: state.highlightedIndex,
      };
    default:
      return changes;
  }
}
